import Api from '@/services/Api'

const URL = 'af/grupo/';

export default {

    fetch(params) {
        return Api().get(URL, {
            params: params
        });
    },

    getById(codigo) {
        return Api().get(`${URL}${codigo}`);
    },

    save(params) {
        if ('pk' in params) {
            return Api().put(`${URL}${params.id}` + '/', params);
        }
        return Api().post(URL, params);
    },

}